import { useEffect } from 'react';
import { logEvent } from "firebase/analytics";
import { analytics } from '../../../firebase';

export default function TicTacToeRedirect() {
  useEffect(() => {
    // 1. Log the redirect event to Firebase Web Analytics
    logEvent(analytics, 'app_share_redirect_clicked', {
      app_name: 'Tic Tac Toe - Infinite',
      platform: 'Play Store',
      timestamp: new Date().toISOString()
    });

    // 2. Define the Play Store URL with UTM parameters for tracking in Google Play Console
    const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.tattvadynamics.tictactoe_infinite&referrer=utm_source%3Dapp_share%26utm_medium%3Dsocial%26utm_campaign%3Dtattva_web';

    // 3. Perform the redirect with a slight delay to allow meta tags to be processed by scrapers
    const timer = setTimeout(() => {
      window.location.href = playStoreUrl;
    }, 1000); // 1 second delay

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center text-white">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-500 mx-auto mb-4"></div>
        <p className="text-gray-400">Redirecting to Play Store...</p>
      </div>
    </div>
  );
}
